export default __webpack_public_path__ + "static/media/logo.5d6c03af.svg";